module.exports = __webpack_public_path__ + "static/media/around_the_world.33ec3c16.jpg";